export default __webpack_public_path__ + "static/media/20_tag_vending-machine.d7b746b5.svg";